<template>
<Edit />
</template>

<script lang="ts">
import Edit from '../components/kbedit/Edit.vue';

export default {
    name: 'main_edit_view',
    components: {
      Edit,
    },
    data() {
        return {

        };
    },

    mounted() {
        document.getElementById('loading')?.remove();
    },
    watch: {
  
    },
    computed: {
        
    },
    methods: {
    },
    unmounted() {
    }
};
</script>

<style lang="scss">
body {
    // min-width: 800px;
    overflow: auto;
    background: #fff;
}

body::-webkit-scrollbar {
    display: none;
}

*:focus-visible {
    outline: none;
}
</style>
